// src/config.ts
function required(name: string, v: string | undefined): string {
  if (!v) throw new Error(`Missing env ${name}. Did you set it in .env.production?`);
  return v;
}

// CRA uses process.env.REACT_APP_*
export const API_BASE = required('REACT_APP_API_BASE', process.env.REACT_APP_API_BASE);
export const WS_BASE  = required('REACT_APP_WS_URL',   process.env.REACT_APP_WS_URL);
export const SSE_BASE = required('REACT_APP_SSE_URL',  process.env.REACT_APP_SSE_URL);

// Helpers (optional)
export const WS_ORIGIN  = WS_BASE.endsWith('/') ? WS_BASE : WS_BASE + '/';
export const SSE_ORIGIN = SSE_BASE.endsWith('/') ? SSE_BASE : SSE_BASE + '/';
